import { SignalCatalog } from "@/components/signals/SignalCatalog";

export function SettingsSignalsPage() {
  return <SignalCatalog />;
}
